import clone from 'clone';

import {AppMode, AppFlags, AppFontDesc} from './app-types';
import AppConfigHelper from './app-config-helper';
import {OEFeatureAccessTypes, UIControllerType, OEHideFlags} from '../react-oe/oe-types';
import {OETarget, OEResourceTarget} from '../react-oe/oe-target';
import {OEVersion} from '../react-oe/oe-version';
import {OEViewType, OEContextMenuContentType, OEStartViewTypes, OECutControllerStyle, UILevel, OEMainMenuControlBarEntryTypes} from '../lib/oe-types';
import oeURLParameterTool, {OEURLParameter} from '../lib/tools/oe-url-parameter-tool';
import LocalStorage from '../lib/tools/local-storage';
import OEIconCodes from '../lib/oe-icon-codes';
import {OEManualViewLinks, OEManualViewConfigFactory} from '../components/views/manual-view/oe-manual-view-model';
import {OETargetMenuDefs} from '../components/elements/target-menu/oe-target-menu-defs';
import {OEMediaCenterItemTypes, OEMediaCenterMode, OEMediaCenterAutoplayMode} from '../components/controller/media-center/oe-media-center-model';
import {OEPresentationPlayableFlags} from '../components/controller/presentation/oe-presentation-model';
import {OEMainMenuStdBtnType, OEMainMenuBtnLocation, OEMainMenuBtnConfigFactory} from '../components/bars/main-menu/oe-main-menu-model';
import OEMainMenuBtnAdapterView from '../components/bars/main-menu/button-adapters/oe-main-menu-btn-adapter-view';
import OEMainMenuBtnAdapterMediaCenterDisableNoLicense from '../components/bars/main-menu/button-adapters/oe-main-menu-btn-adapter-media-center-disable-no-license';
//import OEMainMenuBtnAdapterPostProcess from '../components/bars/main-menu/button-adapters/oe-main-menu-btn-adapter-post-process';
import {OESettingsControlGroupType, OESettingsControlType, OESettingsDefaultControlGroups} from '../components/controller/settings/oe-settings-model';
import {OEHelpViewEntryType, OEHelpViewConfigFactory} from '../components/views/help-view/oe-help-view-model';
import {OEWelcomeViewType} from '../components/views/welcome-view/oe-welcome-view-model';
import {OEInfoMessageViewType} from '../components/views/info-message-view/oe-info-message-model';
//import OEXRayIcarusMainMenuBtnAdapterReset from '../components/custom/xRayIcarus/oe-xray-icarus-main-menu-btn-adapter-reset';
import OEXRayIcarusTextViewAdapter from '../components/custom/xRayIcarus/oe-xray-icarus-text-view-adapter';
import {OEDefaultConfigFactory} from '../components/oe-default-configs';
import {OELicensingAppConfigFactory} from '../components/licensing-start/oe-licensing-app';
import {OEAmbossTargets, OEAmbossFeatureAccess, OEAmbossStartSelectionData} from '../components/custom/amboss/oe-amboss-model';
import {OEAnatomyStartSelectionData} from '../components/custom/anatomy/oe-anatomy-model';
import {OEBayerTargets, OEBayerFeatureAccess, OEBayerStartSelectionData} from '../components/custom/bayer/oe-bayer-model';
import {OEBBraunTargets, OEBBraunFeatureAccess, OEBBraunStartSelectionData} from '../components/custom/bbraun/oe-bbraun-model';
import {OECellStartSelectionData} from '../components/custom/cell/oe-cell-model';
import {OEDemoStartSelectionData} from '../components/custom/demo/oe-demo-model';
import {OEEarStartSelectionData} from '../components/custom/ear/oe-ear-model';
import {OEEquineHoofFeatureAccess, OEEquineHoofStartSelectionData} from '../components/custom/equineHoof/oe-equine-hoof-model';
import {OEImplantcastTargets, OEImplantcastFeatureAccess, OEImplantcastStartSelectionData, OEImplantcastManual} from '../components/custom/implantcast/oe-implantcast-model';
import {OEOrthoStartSelectionData} from '../components/custom/ortho/oe-ortho-model';
import {OESchoolStartSelectionData} from '../components/custom/school/oe-school-model';
import {OEScienceStartSelectionData} from '../components/custom/science/oe-science-model';
import {OESkinStartSelectionData} from '../components/custom/skin/oe-skin-model';
import {OESportStartSelectionData} from '../components/custom/sport/oe-sport-model';
import {OESurgeryTargetType, OESurgeryTargets, OESurgeryLicensingEdition, OESurgeryFeatureAccess, OESurgeryStartSelectionData} from '../components/custom/surgery/oe-surgery-model';
import {OEThiemeStartSelectionData} from '../components/custom/thieme/oe-thieme-model';
import {OEToxnetzStartSelectionData} from '../components/custom/toxnetz/oe-toxnetz-model';
import {OEXRayStartSelectionDataSelector} from '../components/custom/xRay/oe-xray-model';

export default class AppConfig {

    constructor(params) {
        let {target, initial, ...otherParams} = params || {};
        const MMBtnT = OEMainMenuStdBtnType;
        const flags = AppFlags.get();

        //
        this.initial = initial;
        this.className = '';
        this.font = AppFontDesc.defaultFont;
        this.version = config.version;
        this.target = OETarget.humanSkull;
        this.isLicensingStart = false;
        this.startAppMode = AppMode.play;
        this.logo = null;
        this.isFullscreenAvailable = true;

        this.module = {
            version: config.version,
            flags: flags.length ? flags : undefined,
            uiLayerConfig: OEDefaultConfigFactory.uiLayer(),
            licensingManager: {onLicensingProductActivationChanged: undefined},
            labelsEnabled: oeURLParameterTool.getValue(OEURLParameter.labelsEnabled, false),
            labelsLatin: oeURLParameterTool.getValue(OEURLParameter.labelsLatin, false),
            noContextMenu: oeURLParameterTool.getValue(OEURLParameter.noContextMenu),
            featureAccess: {accessType: OEFeatureAccessTypes.isOne(config.accessType) ? config.accessType : OEFeatureAccessTypes.none},
            link: initial ? oeURLParameterTool.getValue(OEURLParameter.link) : undefined,
            uiLink: initial ? oeURLParameterTool.getValue(OEURLParameter.uiLink) : undefined,
            linkRef: initial ? oeURLParameterTool.getValue(OEURLParameter.linkRef) : undefined,
            uiLinkRef: initial ? oeURLParameterTool.getValue(OEURLParameter.uiLinkRef) : undefined,
            uiStateMC: !initial ? undefined : {
                visible: oeURLParameterTool.getValue(OEURLParameter.mcVisible),
                category: oeURLParameterTool.getValue(OEURLParameter.category),
                item: oeURLParameterTool.getValue(OEURLParameter.item),
                resourceId: oeURLParameterTool.getValue(OEURLParameter.resourceId),
                subItem: oeURLParameterTool.getValue(OEURLParameter.subItem),
                progress: oeURLParameterTool.getValue(OEURLParameter.progress)
            },
            urlQuery: oeURLParameterTool.URL,
            loadFlags: oeURLParameterTool.getValue(OEURLParameter.loadFlags),
            license: initial ? oeURLParameterTool.getValue(OEURLParameter.license) : undefined,
        };

        const hasModelLink = typeof(this.module.link) === 'string' || typeof(this.module.linkRef) === 'string';
        const hasLink = hasModelLink || typeof(this.module.uiLink) === 'string' || typeof(this.module.uiLinkRef) === 'string';

        this.licensingAppConfig = OELicensingAppConfigFactory.defaultConfig();

        //
        let isAmboss = config.version === OEVersion.amboss;
        let isAnatomy = config.version === OEVersion.anatomy;
        let isBayer = config.version === OEVersion.bayer;
        let isBBraun = config.version === OEVersion.bbraun;
        let isCambridgeCell = config.version === OEVersion.cambridgeCell;
        let isCell = config.version === OEVersion.cell;
        let isDemo = config.version === OEVersion.demo;
        let isEar = config.version === OEVersion.ear;
        let isEffigos = config.version === OEVersion.effigos;
        let isEquineHoof = config.version === OEVersion.equineHoof;
        let isEyeOCT = config.version === OEVersion.eyeOCT;
        let isImplantcast = config.version === OEVersion.implantcast;
        let isIonto = config.version === OEVersion.ionto;
        let isKind = config.version === OEVersion.kind;
        let isKnowOn = config.version === OEVersion.knowOn;
        let isLicensingStart = config.version === OEVersion.licensingStart || isEffigos;
        let isOrtho = config.version === OEVersion.ortho;
        let isSanten = config.version === OEVersion.santen;
        let isSchool = config.version === OEVersion.school;
        let isScience = config.version === OEVersion.science;
        let isSkin = config.version === OEVersion.skin;
        let isSport = config.version === OEVersion.sport;
        let isSurgery = config.version === OEVersion.surgery;
        let isThieme = config.version === OEVersion.thieme;
        let isToxnetz = config.version === OEVersion.toxnetz;
        let isVisionResearch = config.version === OEVersion.visionResearch;
        let isXRay = config.version === OEVersion.xRay;
        let isXRayMin = config.version === OEVersion.xRayMin;
        let isXRayIcarus = config.version === OEVersion.xRayIcarus;
        let isZeissOpti = config.version === OEVersion.zeissOpti;

        let isLicensing = config.accessType == OEFeatureAccessTypes.licensing;

        let isImport = flags.includes(AppFlags.import);
        let isProduction = flags.includes(AppFlags.production);

        let noTitleBar = oeURLParameterTool.getValue(OEURLParameter.noTitleBar, false);
        let showTitleBar = oeURLParameterTool.getValue(OEURLParameter.showTitleBar);
        let isShowTitleBarSet = typeof(showTitleBar) === 'number';
        let noFullscreen = oeURLParameterTool.getValue(OEURLParameter.noFullscreen, false);
        let showFullscreenBtn = oeURLParameterTool.getValue(OEURLParameter.showFullscreenBtn, true);
        let noStartView = oeURLParameterTool.getValue(OEURLParameter.noStartView, false);
        let showMainMenu = oeURLParameterTool.getValue(OEURLParameter.showMainMenu);
        let isShowMainMenuSet = typeof(showMainMenu) === 'number';
        let autoplay = initial ? oeURLParameterTool.getValue(OEURLParameter.autoplay, OEMediaCenterAutoplayMode.none) : OEMediaCenterAutoplayMode.none;

        //
        this.isFullscreenAvailable = !noFullscreen;
        this.showFullscreenBtn = showFullscreenBtn;

        //
        this.isLicensingStart = isLicensingStart;

        //
        let uiLayerConfig = this.module.uiLayerConfig;
        let targetMenuConfig = uiLayerConfig.targetMenu;

        uiLayerConfig.capBar.available = !noTitleBar;
        if(isShowTitleBarSet)   uiLayerConfig.capBar.showInitially = showTitleBar;

        uiLayerConfig.startView.showAtStartUp = !noStartView;
        if(isShowMainMenuSet)   uiLayerConfig.mainMenuConfig.showInitially = showMainMenu;

        let mainMenuBtnFactory = new OEMainMenuBtnConfigFactory(uiLayerConfig.mainMenuButtons);
        if(isImport)    mainMenuBtnFactory.insertButtonAfterType(MMBtnT.arrow, MMBtnT.userObject);
        if(flags.includes(AppFlags.pwaSW))    mainMenuBtnFactory.insertButtonAfterType(MMBtnT.settings, MMBtnT.offlineManager);

        let helpViewFactory = new OEHelpViewConfigFactory(uiLayerConfig.helpView);

        let manualViewFactory = new OEManualViewConfigFactory(uiLayerConfig.manualView);

        uiLayerConfig.widgetConfig.componentController.searchBar = isImport;

        uiLayerConfig.mediaCenter.autoplay = autoplay;

        // non target specific setup for version
        //------------------------------------------------------------------------

        if(isAmboss) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.amboss, {startViewType: OEStartViewTypes.amboss, contextMenuContent: {type: OEContextMenuContentType.infoBox, showReferences: false}});

            uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && !oeURLParameterTool.getValue(OEURLParameter.target);

            this.font = new AppFontDesc('Lato, Roboto, sans-serif', ['fonts/lato/lato.css', 'fonts/roboto/roboto.css']);

            mainMenuBtnFactory
            .removeButtonByType(isImport ? [MMBtnT.explode] : [MMBtnT.presentation, MMBtnT.note, MMBtnT.arrow, MMBtnT.color, MMBtnT.explode]);

            uiLayerConfig.widgetConfig.labelController.enabled = isImport;
            uiLayerConfig.widgetConfig.cutController.style = isImport ? OECutControllerStyle.std : OECutControllerStyle.minimal;
            uiLayerConfig.widgetConfig.componentController.colorBtnEnabled = isImport;
            uiLayerConfig.widgetConfig.componentController.catSwitchBtnEnabled = isImport;
            uiLayerConfig.widgetConfig.componentController.catActivationBtnEnabled = isImport;

         } else if(isAnatomy) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.anatomy, {startViewType: OEStartViewTypes.anatomy, contextMenuContent: {type: OEContextMenuContentType.infoBox, showReferences: false}});

         } else if(isBayer || isEyeOCT || isKnowOn) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.humanEyeRes, {startViewType: OEStartViewTypes.bayer, withSubstructure: false, mcBigPlayBtnStyle: false});

        } else if(isBBraun)    {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.bbraun, {startViewType: OEStartViewTypes.bbraun});

            uiLayerConfig.welcomeView.type = OEWelcomeViewType.disclaimer;
            uiLayerConfig.welcomeView.srcId = 'disclaimer';
            uiLayerConfig.welcomeView.coreHideFlags = OEHideFlags.scene;
            uiLayerConfig.welcomeView.showStartView = !noStartView && !hasLink;

            uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && LocalStorage.getItem('disclaimerWasAccepted') === 'true';

        } else if(isCambridgeCell || isCell)  {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.cell, {startViewType: OEStartViewTypes.cell, contextMenuContent: {type: OEContextMenuContentType.infoBox, showReferences: false}});

            if(isCambridgeCell) {
                uiLayerConfig.welcomeView.type = OEWelcomeViewType.cambridgeCell;
                uiLayerConfig.welcomeView.showAtStartUp = !noStartView && !hasLink;
                uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && LocalStorage.getItem('dontShowWelcomeViewAtStartUp') === 'true';

                uiLayerConfig.widgetConfig.labelController.enabled = isImport;

                //manualViewFactory.set(OEManualViewConfigFactory.buildCambridgeCellConfig());
                //manualViewFactory.setVideoTutorialLink();
            }

        } else if(isDemo) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.demoRes, {startViewType: OEStartViewTypes.demo, contextMenuContent: {type: OEContextMenuContentType.infoBox, showReferences: false}, mcPresPlayableFlags: OEPresentationPlayableFlags.audioAnimatableSlideAttribute});

         } else if(isEar) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.humanEarRes, {startViewType: OEStartViewTypes.ear});

        } else if(isEffigos) {

            targetMenuConfig.entries = OETargetMenuDefs.app;

        } else if(isEquineHoof) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.hoof, {startViewType: OEStartViewTypes.equineHoof});

        } else if(isKind) {

            this.target = OETarget.humanEarMacro;
            targetMenuConfig.entries = OETargetMenuDefs.kind;

            uiLayerConfig.mainMenuControlBar.entries.push({type: OEMainMenuControlBarEntryTypes.logo, src: 'images/logo_KIND_128.png'});

        } else if(isImplantcast)    {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.implantcast, {startViewType: OEStartViewTypes.implantcast});

            //uiLayerConfig.welcomeView.type = OEWelcomeViewType.disclaimer;
            uiLayerConfig.welcomeView.type = OEWelcomeViewType.register;
            uiLayerConfig.welcomeView.srcId = 'disclaimer';
            uiLayerConfig.welcomeView.privacySrcId = 'privacy_disclaimer';
            uiLayerConfig.welcomeView.coreHideFlags = OEHideFlags.scene;
            uiLayerConfig.welcomeView.showStartView = !noStartView && !hasLink;
            uiLayerConfig.welcomeView.noAcceptTermsCheckbox = true;

            //uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && LocalStorage.getItem('disclaimerWasAccepted') === 'true';
            uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && LocalStorage.getItem('termsWereAccepted') === 'true';

        } else if(isOrtho) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.ortho, {startViewType: OEStartViewTypes.ortho});

        } else if(isSanten) {

            this.target = OETarget.humanEye2;
            this.resourceTarget = OEResourceTarget.santen;
            targetMenuConfig.entries = OETargetMenuDefs.humanEyeSanten;

        } else if(isSchool) {

            mainMenuBtnFactory.insertButtonAfterType(MMBtnT.settings, MMBtnT.secondarySettings);

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.school, {startViewType: OEStartViewTypes.school, contextMenuContent: {type: OEContextMenuContentType.infoBox, showReferences: false}, infoMessageView: {type: OEInfoMessageViewType.std}});

        } else if(isScience) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.science, {startViewType: OEStartViewTypes.science, contextMenuContent: {type: OEContextMenuContentType.infoBox, showReferences: false}});

        } else if(isSkin || isIonto) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.humanSkinRes, {startViewType: isIonto ? OEStartViewTypes.ionto : OEStartViewTypes.skin, mcPresPlayableFlags: OEPresentationPlayableFlags.all});

        } else if(isSport) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.sport, {startViewType: OEStartViewTypes.sport, contextMenuContent: {type: OEContextMenuContentType.infoBox, showReferences: false}});

        } else if(isSurgery) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.surgery, {startViewType: OEStartViewTypes.surgery});

            uiLayerConfig.welcomeView.type = OEWelcomeViewType.disclaimer;
            uiLayerConfig.welcomeView.srcId = 'disclaimer';
            uiLayerConfig.welcomeView.coreHideFlags = OEHideFlags.scene;
            uiLayerConfig.welcomeView.showStartView = !noStartView && !hasLink;

            uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && LocalStorage.getItem('disclaimerWasAccepted') === 'true';

        } else if(isThieme) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.thieme, {startViewType: OEStartViewTypes.thieme});

            this.font = new AppFontDesc('"Thieme Argo 2011", Roboto, sans-serif', ['fonts/thieme-argo/argo.css', 'fonts/roboto/roboto.css']);

            uiLayerConfig.widgetConfig.screenshotController.showUsageRightsBtn = true;
            uiLayerConfig.widgetConfig.screenshotController.attributionOptional = false;
            uiLayerConfig.widgetConfig.screenshotController.copyToClipboardOption = false;

        } else if(isToxnetz) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.toxnetzRes, {startViewType: OEStartViewTypes.toxnetz, contextMenuContent: {type: OEContextMenuContentType.infoBox, showReferences: false}});

        } else if(isVisionResearch) {

            this.target = OETarget.sensorySystems;
            targetMenuConfig.enabled = false;

        } else if(isXRay) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.xRayRes, {startViewType: OEStartViewTypes.xRay});

        } else if(isXRayMin) {

            AppConfigHelper.modernPreTargetSetup(this, null, OEResourceTarget.xRayMinRes, {startViewType: OEStartViewTypes.xRay});

        } else if(isXRayIcarus)  {

            this.target = OETarget.xRayIcarus;
            this.resourceTarget = OEResourceTarget.xRayIcarusRes;
            uiLayerConfig.rightTopBar.enabled = false;

            if(!isShowMainMenuSet)   uiLayerConfig.mainMenuConfig.showInitially = true;
            uiLayerConfig.mainMenuControlBar.enabled = false;

            helpViewFactory.stdInteractiveManualManualVideo();
            manualViewFactory.stdPDF(true);
            manualViewFactory.setVideoTutorialLink();

        } else if(isZeissOpti)  {

            this.target = OETarget.zeissOpti2;
            this.resourceTarget = OEResourceTarget.zeiss;
            uiLayerConfig.startView.type = OEStartViewTypes.zeissOpti;
            uiLayerConfig.startView.targetViewShowedAtStartFlag = true;
            uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink;

            uiLayerConfig.rightTopBar.enabled = false;
            if(!isShowMainMenuSet)   uiLayerConfig.mainMenuConfig.showInitially = true;
            uiLayerConfig.mainMenuControlBar.enabled = false;

            helpViewFactory.stdManualVideoTutorial();
            manualViewFactory.stdPDF();
        }

        // set final target
        //------------------------------------------------------------------------
        let info = {targetChoiceTag: 0};
        this.target = AppConfigHelper.selectTarget(target, info) || this.target;
        if(!this.resourceTarget)    this.resourceTarget = AppConfigHelper.selectResourceTarget(this.target);
        this.target = OEResourceTarget.defaultTargetForResourceTarget(this.target);

        // set app mode at start up
        this.startAppMode = isLicensingStart && info.targetChoiceTag == 0 ? AppMode.start : AppMode.play;

        //
        AppConfigHelper.setupTargetMenuConfig(targetMenuConfig, this.target);


        // further ui configs with respect to choosen target
        //------------------------------------------------------------------------

        // choose logo for start, info, fremium view
        let logo = AppConfigHelper.logoFor(this.target, config.version);
        uiLayerConfig.welcomeView.logo = logo;
        uiLayerConfig.startView.logo = logo;
        uiLayerConfig.freePremiumView.logo = logo;
        uiLayerConfig.infoView.logo = logo;

        if(isAmboss) {
            AppConfigHelper.modernPostTargetSetup(this, {
                startSelectionContent: OEAmbossStartSelectionData.chooseModules(),
                startSelectionLicensingAccess: (sender, licensingAccess, oe) => {
                    return OEAmbossFeatureAccess.isModuleAvailableForLicensingAccess(licensingAccess);
                },
                startSelectionModuleLicensingAccess: (sender, module, licensingAccess, oe) => {
                    return OEAmbossFeatureAccess.isModuleAvailableForLicensingAccess(licensingAccess, module.id);
                },
                startSelectionItemLicensingAccess: (sender, item, path, licensingAccess, oe) => {
                    return OEAmbossFeatureAccess.isTargetSelectionAvailableForLicensingAccess(licensingAccess, path.module.id) || OEAmbossTargets.isDemoTarget(item.target);
                },
            });
        }

        if(isAnatomy) {
            let isHelpTarget = this.target === OETarget.effigosExplorerHelp;

            // if(!isHelpTarget)    {
            //     uiLayerConfig.logo = {src: 'images/logo_effigos_dark.png'/*, mask: {uiController: UIControllerType.media_center}*/};
            // }

            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OEAnatomyStartSelectionData.chooseModules()});
        }

        if(isBBraun)    {
            let isOpTarget = OEBBraunTargets.isOpTarget(this.target);
            let isHelpTarget = this.target === OETarget.effigosExplorerHelp;

            if(isOpTarget || isHelpTarget)  {
                this.font = new AppFontDesc('Arial, Roboto, sans-serif', ['fonts/roboto/roboto.css']);
            }

            if(isOpTarget)    {
                this.className = 'op-target';

                uiLayerConfig.logo = {src: 'images/logo_bbraun.png'/*, mask: {uiController: UIControllerType.media_center}*/};

                mainMenuBtnFactory.removeButtonByType([MMBtnT.explode]);
            }

            if(!isOpTarget && !isHelpTarget)    {
                uiLayerConfig.logo = {src: 'images/logo_effigos_dark.png'/*, mask: {uiController: UIControllerType.media_center}*/};
            }

            uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && LocalStorage.getItem('disclaimerWasAccepted') === 'true';

            AppConfigHelper.modernPostTargetSetup(this, {
                startSelectionContent: OEBBraunStartSelectionData.chooseModules(flags),
                startSelectionLicensingAccess: (sender, licensingAccess, oe) => {
                    return OEBBraunFeatureAccess.isModuleAvailableForLicensingAccess(licensingAccess);
                },
                startSelectionModuleLicensingAccess: (sender, module, licensingAccess, oe) => {
                    return OEBBraunFeatureAccess.isModuleAvailableForLicensingAccess(licensingAccess, module.id);
                },
                startSelectionItemLicensingAccess: (sender, item, path, licensingAccess, oe) => {
                    return OEBBraunFeatureAccess.isTargetSelectionAvailableForLicensingAccess(licensingAccess, path.module.id) || OEBBraunTargets.isDemoTarget(item.target);
                },
                bottomWidgetToolbarMCWidget: {showIndex: !isOpTarget, showStats: !isOpTarget},
                //videoTutorial: isOpTarget ? 'bbraun_tutorial_video' : 'tutorial_video'
            });

            if(isOpTarget)   uiLayerConfig.widgetConfig.screenshotController.attribution.textID = 'screenshot_attribution_bbraun';
        }

        if(isCambridgeCell || isCell) {
            AppConfigHelper.modernPostTargetSetup(this, {
                startSelectionContent: OECellStartSelectionData.chooseModules(),
                startSelectionForHelpTarget: true,
                bottomWidgetToolbarMCWidget: {categoryName: this.target == OETarget.animalCell ? 'AnimationsPresentations' : 'Presentations', categoryMaskOrder: this.target == OETarget.animalCell ? [8, 3 << 30] : undefined, showIcon: true},
            });

            if(isCambridgeCell) {
                mainMenuBtnFactory
                .removeButtonByType([MMBtnT.cut])
                .insertButtonAfterType(MMBtnT.help, {type: 'welcome-view', icon: OEIconCodes.cell.cambridgeWelcomeView, adapter: new OEMainMenuBtnAdapterView(OEViewType.welcome)});
            }
        }

        if(isDemo) {
            let isIdoTarget = this.target === OETarget.surgeryIdo;
            let isImplantcastTarget = this.target === OETarget.implantcastEcoFitHipStem;
            let isLinkTarget = this.target === OETarget.surgeryLinkEmbrace;
            let isHelpTarget = this.target === OETarget.effigosExplorerHelp;

            if(isIdoTarget) {
                uiLayerConfig.logo = {src: 'images/logo_ido.png'/*, mask: {uiController: UIControllerType.media_center}*/};
            } else if(isImplantcastTarget) {
                uiLayerConfig.logo = {src: 'images/logo_implantcast.png'/*, mask: {uiController: UIControllerType.media_center}*/};
            } else if(isLinkTarget) {
                uiLayerConfig.logo = {src: 'images/logo_link.png'/*, mask: {uiController: UIControllerType.media_center}*/};
            }

            if([OETarget.implantcastEcoFitHipStem, OETarget.surgeryIdo, OETarget.surgeryLinkEmbrace].includes(this.target)) {
                uiLayerConfig.welcomeView.type = OEWelcomeViewType.disclaimer;
                uiLayerConfig.welcomeView.srcId = 'disclaimer';
                uiLayerConfig.welcomeView.coreHideFlags = OEHideFlags.scene;
                uiLayerConfig.welcomeView.showStartView = !noStartView && !hasLink && initial;

                uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && LocalStorage.getItem('disclaimerWasAccepted') === 'true';
            }

            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OEDemoStartSelectionData.chooseModules()});
        }

        if(isEar)   {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OEEarStartSelectionData.chooseModules(), startSelectionForHelpTarget: true});
        }

        if(isEquineHoof) {
            AppConfigHelper.modernPostTargetSetup(this, {
                startSelectionContent: OEEquineHoofStartSelectionData.chooseWithTarget(this.target),
                startSelectionLicensingAccess: (sender, licensingAccess, oe) => OEEquineHoofFeatureAccess.isTargetSelectionAvailableForLicensingAccessTarget(licensingAccess, this.target),
                bottomWidgetToolbarMCWidget: {categoryName: this.target == OETarget.hoofDynamics ? 'Animations' : 'Presentations', showIcon: true}
            });
        }

        if(isImplantcast)    {
            let isOpTarget = OEImplantcastTargets.isOpTarget(this.target);
            let isHelpTarget = this.target === OETarget.effigosExplorerHelp;
            let videoTutorial = isOpTarget ? 'implantcast_tutorial_video' : 'tutorial_video';

            if(isOpTarget || isHelpTarget)  {
                this.font = new AppFontDesc('Implantcast, Roboto, sans-serif', ['fonts/implantcast/implantcast.css', 'fonts/roboto/roboto.css']);
            }

            if(isOpTarget)  {
                this.className = 'op-target';

                uiLayerConfig.logo = {src: 'images/logo_implantcast.png'/*, mask: {uiController: UIControllerType.media_center}*/};

                mainMenuBtnFactory.removeButtonByType([MMBtnT.explode]);

                if(!isImport)   mainMenuBtnFactory.removeButtonByType([MMBtnT.note, MMBtnT.arrow, MMBtnT.color, MMBtnT.presentation]);
            }

            if(!isOpTarget && !isHelpTarget)    {
                uiLayerConfig.logo = {src: 'images/logo_effigos_dark.png'/*, mask: {uiController: UIControllerType.media_center}*/};
            }

            AppConfigHelper.modernPostTargetSetup(this, {
                startSelectionContent: OEImplantcastStartSelectionData.chooseModules(flags),
                startSelectionLicensingAccess: (sender, licensingAccess, oe) => {
                    return OEImplantcastFeatureAccess.isModuleAvailableForLicensingAccess(licensingAccess);
                },
                startSelectionModuleLicensingAccess: (sender, module, licensingAccess, oe) => {
                    return OEImplantcastFeatureAccess.isModuleAvailableForLicensingAccess(licensingAccess, module.id);
                },
                startSelectionItemLicensingAccess: (sender, item, path, licensingAccess, oe) => {
                    return !licensingAccess.isLicensing || licensingAccess.isValid || OEImplantcastTargets.isOpTarget(item.target) || OEImplantcastTargets.isDemoTarget(item.target);
                },
                startSelectionShowFreePremiumView: true,
                bottomWidgetToolbarMCWidget: {showIndex: !isOpTarget, showStats: !isOpTarget},
                videoTutorial: videoTutorial
            });

            if(!isImport)   {
                uiLayerConfig.widgetConfig.cutController.style = OECutControllerStyle.minimal;
                uiLayerConfig.widgetConfig.cutController.enableTouchShift = true;
            }

            if(isOpTarget)   {
                manualViewFactory.setLinks(OEImplantcastManual.getOpManualLinks());
                manualViewFactory.setVideoTutorialLink(videoTutorial);

                uiLayerConfig.widgetConfig.screenshotController.attribution.textID = 'screenshot_attribution_implantcast';
            }
        }

        if(isOrtho) {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OEOrthoStartSelectionData.chooseModules()});
        }

        if(isSchool) {
            AppConfigHelper.modernPostTargetSetup(this, {
                startSelectionContent: OESchoolStartSelectionData.chooseModules(),
                startSelectionLicensingAccess: (sender, licensingAccess, oe) => true,
                bottomWidgetToolbarMCWidget: {forHelpTarget: true}
            });

            mainMenuBtnFactory.modifyButtonByType(MMBtnT.mediaCenter, (btn) => { btn.adapter = new OEMainMenuBtnAdapterMediaCenterDisableNoLicense(false); });

            if(!isImport)   {
                uiLayerConfig.widgetConfig.labelController.enabled = false;
                uiLayerConfig.widgetConfig.cutController.style = OECutControllerStyle.minimal;
                uiLayerConfig.widgetConfig.cutController.enableTouchShift = true;
            }

            let licenseMaskedSettingsControls = [
                OESettingsControlType.languageSwitch,
                OESettingsControlType.vignette,
                OESettingsControlType.ambientOcclusion,
                OESettingsControlType.compHighlightingLabels,
                OESettingsControlType.compHighlightingVP,
                OESettingsControlType.touchSensitivity
            ];

            let alphaMaskedSettingsControls = [];

            uiLayerConfig.widgetConfig.settingsController.controls.forEach(group => {
                group.controls.forEach(control => {
                    if(control.type === OESettingsControlType.vpGizmo && !flags.includes(AppFlags.alpha))    control.data = {alignmentControl: false};

                    if(!flags.includes(AppFlags.alpha) && alphaMaskedSettingsControls.includes(control.type))  {
                        control.mask = {masked: true};
                        return;
                    }

                    if(licenseMaskedSettingsControls.includes(control.type))   {
                        control.mask = {licenseValid: true};
                    }
                });
            });
        }

        if(isScience) {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OEScienceStartSelectionData.chooseModules(), startSelectionForHelpTarget: true});
        }

        if(isSkin || isIonto) {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OESkinStartSelectionData.chooseModules(), startSelectionForHelpTarget: true});
        }

        if(isSport) {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OESportStartSelectionData.chooseModules(), startSelectionForHelpTarget: true});
        }

        if(isSurgery)   {
            let isIdoTarget = this.target === OETarget.surgeryIdo;
            let isOHSTTarget = this.target === OETarget.surgeryOHSTPrimaCurve;
            let isAnatomyTarget = OESurgeryTargets.isAnatomyTarget(this.target);
            let isImplantcastTarget = OESurgeryTargets.isApproachOpTarget(this.target);
            let isSurgeryCataractTarget = this.target === OETarget.surgeryEyeCataract;
            let isHelpTarget = this.target === OETarget.effigosExplorerHelp;
            let isOpTarget = OESurgeryTargets.isOrthoOpTarget(this.target) || OESurgeryTargets.isApproachOpTarget(this.target);

            if(isOpTarget)  {
                // uiLayerConfig.logo = {src: 'images/surgery_logo.png'/*, mask: {uiController: UIControllerType.media_center}*/};

                mainMenuBtnFactory.removeButtonByType([MMBtnT.explode]);
            }

            if(!isHelpTarget) {
                const groups = [
                    {active: isImplantcastTarget,                           logo: 'logo_implantcast.png'},
                    {active: isIdoTarget,                                   logo: 'logo_ido.png'},
                    {active: isOHSTTarget,                                  logo: 'logo_ohst.png'},
                    {active: isAnatomyTarget || isSurgeryCataractTarget,    logo: 'logo_effigos_dark.png'},
                ];

                const activeGroups = groups.filter(g => g.active);
                if(activeGroups.length === 1) {
                    uiLayerConfig.logo = {src: `images/${activeGroups[0].logo}`};
                }
            }

            uiLayerConfig.startView.showAtStartUp = !noStartView && !hasLink && LocalStorage.getItem('disclaimerWasAccepted') === 'true';

            AppConfigHelper.modernPostTargetSetup(this, {
                startSelectionContent: OESurgeryStartSelectionData.chooseModules(flags),
                startSelectionLicensingAccess: (sender, licensingAccess, oe) => {
                    return OESurgeryFeatureAccess.isModuleAvailableForLicensingAccess(licensingAccess);
                },
                startSelectionModuleLicensingAccess: (sender, module, licensingAccess, oe) => {
                    return OESurgeryFeatureAccess.isModuleAvailableForLicensingAccess(licensingAccess, module.id);
                },
                startSelectionItemLicensingAccess: (sender, item, path, licensingAccess, oe) => {
                    let isIDO = licensingAccess.isValid && licensingAccess.edition == OESurgeryLicensingEdition.IDO;
                    let isIDOEditionAnatomy = isIDO && path.module.id == OESurgeryTargetType.anatomy;
                    return (
                        (OESurgeryFeatureAccess.isTargetSelectionAvailableForLicensingAccess(licensingAccess, path.module.id) && !isIDOEditionAnatomy) ||
                        OESurgeryTargets.isDemoTarget(item.target) ||
                        item.target == OETarget.surgeryOHSTPrimaCurve ||
                        (isIDO && item.target == OETarget.humanShoulderGirdle)
                    );
                },
                //bottomWidgetToolbarMCWidget: {showIndex: !isOpTarget, showStats: !isOpTarget},
                //videoTutorial: isOpTarget ? 'surgery_tutorial_video' : 'tutorial_video'
            });
        }

        if(isThieme) {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OEThiemeStartSelectionData.chooseModules()});

            if(isProduction && !isImport)   mainMenuBtnFactory.removeButtonByType([MMBtnT.presentation, MMBtnT.note, MMBtnT.arrow, MMBtnT.color]);

            helpViewFactory.removeEntryByType(OEHelpViewEntryType.manualInteractive);
            if(hasModelLink || autoplay !== OEMediaCenterAutoplayMode.none) helpViewFactory.removeEntryByType(OEHelpViewEntryType.manual, e => e.link === OEManualViewLinks.videoTutorial);
        }

        if(isXRay) {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OEXRayStartSelectionDataSelector.get(this.version).chooseModules()});
        }

        if(isXRayMin) {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: []});
        }

        if(isXRayIcarus)  {
            let isHelpTarget = this.target === OETarget.effigosExplorerHelp;

            targetMenuConfig.enabled = this.target != OETarget.xRayIcarus && !isHelpTarget;
            targetMenuConfig.entries = flags.includes(AppFlags.reduced) ? OETargetMenuDefs.xRayIcarusVersionReduced : (flags.includes(AppFlags.alpha) || flags.includes(AppFlags.beta) ? OETargetMenuDefs.xRayIcarusVersionBeta : OETargetMenuDefs.xRayIcarusVersion);

            uiLayerConfig.widgetConfig.showHelp = false;

            /*
            if(!isImport)   {
                uiLayerConfig.widgetConfig.labelController.enabled = false;
                uiLayerConfig.widgetConfig.cutController.style = OECutControllerStyle.minimal;
            }
            */

            uiLayerConfig.startView.showAtStartUp = false;

            //
            if(this.target == OETarget.xRayIcarus)   {
                //this.logo = 'images/logo_philips.png'

                uiLayerConfig.widgetConfig.textViewController = OEDefaultConfigFactory.textViewController(new OEXRayIcarusTextViewAdapter());
            }

            //
            if(this.target == OETarget.xRayIcarus)   {
                mainMenuBtnFactory
                .removeButtonByType([MMBtnT.presentation, MMBtnT.mediaCenter, MMBtnT.arrow, MMBtnT.note, MMBtnT.userObject, /*MMBtnT.substructure,*/ MMBtnT.explode, MMBtnT.info])
                //.replaceButtonByType(MMBtnT.home, {type: 'home-icarus', icon: OEIconCodes.home, tooltip: 'main_menu_tooltip_home', adapter: new OEXRayIcarusMainMenuBtnAdapterReset()})
                .insertButtonAfterType(MMBtnT.home /*'home-icarus'*/, {type: 'text-view', icon: OEIconCodes.info, tooltip: 'main_menu_tooltip_text_view', adapter: new OEMainMenuBtnAdapterView(OEViewType.text)});
            } else {
                mainMenuBtnFactory.removeButtonByType([MMBtnT.info]);
            }

            //
            if(this.target == OETarget.xRayIcarus)   {
                uiLayerConfig.mediaCenter.mode = OEMediaCenterMode.bottomBar;
                uiLayerConfig.mediaCenter.hideBottomBarControlsForItems = [OEMediaCenterItemTypes.none, OEMediaCenterItemTypes.animation, OEMediaCenterItemTypes.image, OEMediaCenterItemTypes.pdf];
                uiLayerConfig.mediaCenter.hideSliderForItems = [OEMediaCenterItemTypes.animation, OEMediaCenterItemTypes.image, OEMediaCenterItemTypes.pdf];
            } else {
                uiLayerConfig.mediaCenter = OEDefaultConfigFactory.mediaCenter(true, autoplay);
            }

            //
            if(isLicensing) {
                mainMenuBtnFactory.insertButtonInFrontOfType(MMBtnT.settings, {type: MMBtnT.info, icon: OEIconCodes.key, tooltip: 'main_menu_tooltip_license'});

                uiLayerConfig.infoView.isMaximized = true;
                uiLayerConfig.infoView.header = false;
                uiLayerConfig.infoView.tutorials = false;
            }

            //
            mainMenuBtnFactory.insertButtonAfterType(MMBtnT.settings, MMBtnT.help);

            //helpViewFactory.setLogo(logo);
            if(!isHelpTarget)   helpViewFactory.removeTutorEntries();
        }

        if(isToxnetz) {
            AppConfigHelper.modernPostTargetSetup(this, {startSelectionContent: OEToxnetzStartSelectionData.chooseModules()});
        }

        //
        let isTargetZeissOpti = this.target === OETarget.zeissOpti || this.target === OETarget.zeissOpti2;
        let isTargetZeiss = isTargetZeissOpti || this.target === OETarget.zeissUV;
        let isZeiss = isTargetZeiss || isZeissOpti;
        if(isZeiss)   {
            mainMenuBtnFactory
            .clear()
            .insertButtonAtIndex(OEMainMenuBtnLocation.top, 0, [MMBtnT.home, MMBtnT.label, MMBtnT.color, MMBtnT.mediaCenter, MMBtnT.screenshot, {type: MMBtnT.help, adapter: new OEMainMenuBtnAdapterView(OEViewType.help)}, MMBtnT.settings]);
            if(isLicensing) mainMenuBtnFactory.insertButtonAfterType(MMBtnT.settings, {type: MMBtnT.info, icon: OEIconCodes.key, tooltip: 'main_menu_tooltip_license'});

            if(isZeissOpti) {
                targetMenuConfig.enabled = false;

                if(!isShowMainMenuSet)   uiLayerConfig.mainMenuConfig.showInitially = true;
                uiLayerConfig.widgetConfig.cutController.showHelp = false;

                //
                mainMenuBtnFactory
                //.replaceButtonByType(MMBtnT.color, {type: 'postProcess', icon: OEIconCodes.zeissOpti.pencil, tooltip: 'main_menu_tooltip_stylized', adapter: new OEMainMenuBtnAdapterPostProcess()})
                .modifyButtonByType(MMBtnT.color, btn => { btn.tooltip = 'main_menu_tooltip_stylized'; });

                if(isTargetZeiss)   {
                    mainMenuBtnFactory.removeButtonByType(MMBtnT.mediaCenter);
                    if(!isTargetZeissOpti)  mainMenuBtnFactory.removeButtonByType(MMBtnT.color);
                }

                //
                if(isTargetZeiss)    {
                    uiLayerConfig.widgetConfig.labelController.enabled = false;
                    uiLayerConfig.widgetConfig.componentController.colorPurityControl = false;

                    this.logo = 'images/logo_zeiss.png';

                } else {
                    // add ui level entry to settings controller for non zeiss targets
                    uiLayerConfig.widgetConfig.settingsController.controls.push(clone(OESettingsDefaultControlGroups.uiAdvanced));

                    targetMenuConfig.enabled = true;
                    targetMenuConfig.entries = OETargetMenuDefs.humanEyeAnatomyZeiss;
                    targetMenuConfig[UILevel.advanced] = clone(targetMenuConfig);

                    // main menu config for ui level - advanced
                    let mainMenuBtnFactoryAdvanced = new OEMainMenuBtnConfigFactory()
                    .std()
                    .modifyButtonByType(MMBtnT.color, btn => { btn.tooltip = 'main_menu_tooltip_stylized'; })
                    //.replaceButtonByType(MMBtnT.color, {type: 'postProcess', icon: OEIconCodes.zeissOpti.pencil, tooltip: 'main_menu_tooltip_stylized', adapter: new OEMainMenuBtnAdapterPostProcess()})
                    .replaceButtonByType(MMBtnT.info, {type: MMBtnT.help, adapter: new OEMainMenuBtnAdapterView(OEViewType.help)});

                    if(isLicensing) mainMenuBtnFactoryAdvanced.insertButtonAfterType(MMBtnT.settings, {type: MMBtnT.info, icon: OEIconCodes.key, tooltip: 'main_menu_tooltip_license'});

                    uiLayerConfig.mainMenuButtons[UILevel.advanced] = mainMenuBtnFactoryAdvanced.build();

                    // widget config for ui level
                    uiLayerConfig.widgetConfig.labelController.enabled = false;
                    uiLayerConfig.widgetConfig.labelController[UILevel.advanced] = OEDefaultConfigFactory.labelController();

                    uiLayerConfig.widgetConfig.componentController.enabled = false;
                    uiLayerConfig.widgetConfig.componentController.colorPurityControl = false;
                    uiLayerConfig.widgetConfig.componentController[UILevel.advanced] = OEDefaultConfigFactory.componentController({searchBar: isImport, colorPurityControl: false});
                }

                let graphicsGroup = uiLayerConfig.widgetConfig.settingsController.controls.find(group => group.type === OESettingsControlGroupType.graphics);
                graphicsGroup.controls = graphicsGroup.controls.filter(control => control.type !== OESettingsControlType.rendererPreset);

            } else {
                if(!isTargetZeissOpti)  {   // target is zeiss uv here
                    // main menu config for legacy uv version
                    mainMenuBtnFactory.std().replaceLocation(OEMainMenuBtnLocation.top, [MMBtnT.home, MMBtnT.tree, MMBtnT.label, MMBtnT.mediaCenter, MMBtnT.cut, MMBtnT.presentation, MMBtnT.screenshot, MMBtnT.info, MMBtnT.settings]);
                }
            }

            //
            uiLayerConfig.widgetConfig.cutController.enabled = !(isZeissOpti && isTargetZeiss);

            //
            if(this.target === OETarget.zeissUV && !isZeissOpti)   uiLayerConfig.welcomeView.type = OEWelcomeViewType.zeissUV;

            //
            uiLayerConfig.infoView.logo = null;

            if(isZeissOpti || isTargetZeissOpti)  {
                uiLayerConfig.infoView.isMaximized = true;
                uiLayerConfig.infoView.header = false;
                uiLayerConfig.infoView.tutorials = false;
            } else {
                uiLayerConfig.infoView.mediaContent = ['info_view_media_video_1_youtube', 'info_view_media_video_2_youtube'];
            }

            // media center config changes
            if((isZeissOpti && isTargetZeiss) || (!isZeissOpti && isTargetZeissOpti))   {
                uiLayerConfig.mediaCenter.mode = OEMediaCenterMode.bottomBar;
                uiLayerConfig.mediaCenter.hideBottomBarControlsForItems = [OEMediaCenterItemTypes.none, OEMediaCenterItemTypes.animation, OEMediaCenterItemTypes.image, OEMediaCenterItemTypes.pdf];
                uiLayerConfig.mediaCenter.hideSliderForItems = [OEMediaCenterItemTypes.animation, OEMediaCenterItemTypes.image, OEMediaCenterItemTypes.pdf];
            }
        }

        //
        if(isBayer || isEyeOCT || isKnowOn)    {
            if(isTargetZeiss)   {
                mainMenuBtnFactory.removeButtonByType([MMBtnT.mediaCenter, MMBtnT.color]);
                this.logo = 'images/logo_zeiss.png';
            }

            if(!isTargetZeiss)    {
                uiLayerConfig.mediaCenter = OEDefaultConfigFactory.mediaCenter(true, autoplay);
            }

            if(!mainMenuBtnFactory.hasButton(MMBtnT.infoHelp))  mainMenuBtnFactory.insertButtonInFrontOfType(MMBtnT.help, MMBtnT.infoHelp);

            AppConfigHelper.modernPostTargetSetup(this, {
                startSelectionContent: OEBayerStartSelectionData.chooseWithTarget(this.target),
                startSelectionLicensingAccess: (sender, licensingAccess, oe) => OEBayerFeatureAccess.isTargetSelectionAvailableForLicensingAccessTarget(licensingAccess, this.target)
            });

            if(OEBayerTargets.isBayerTarget(this.target))   {
                this.className = 'bayer-target';

                uiLayerConfig.widgetConfig.screenshotController.attribution.textID = 'screenshot_attribution_bayer';

                uiLayerConfig.logo = {src: 'images/logo_bayer.png'/*, mask: {uiController: UIControllerType.media_center}*/};
            }

            if(OEBayerTargets.isOptiTarget(this.target))   {
                this.className = 'opti-target';

                uiLayerConfig.widgetConfig.bottomWidgetToolbar = OEDefaultConfigFactory.bottomWidgetToolbar();
            }

            if(OEBayerTargets.isOCTTarget(this.target))   {
                this.className = 'oct-target';

                uiLayerConfig.logo = {src: 'images/logo_eye_oct.png', mask: {uiController: UIControllerType.media_center}};
            }
        }

        // customer logo
        let customer = oeURLParameterTool.getValue(OEURLParameter.customer);
        if(customer) {
            switch (customer) {
                case 'med-el': this.logo = 'images/logo_medel.png'; break;
                default: this.logo = 'images/logo_' + customer + '.png';
            }
        }
    }
}